import { darken, lighten } from "@mui/material";
import { COLOR_BLACK, COLOR_PRIMARY, COLOR_WHITE } from "helpers/colors";
import React from "react";

export default function PlayerAvatar({ color, inverse = false, playerNumber, size = 32, ...others }) {
  color ||= COLOR_PRIMARY;

  let textColor = inverse ? COLOR_BLACK : COLOR_WHITE;
  let backgroundColor = inverse ? darken(color, 0.1) : lighten(color, 0.1);

  return (
    <div
      {...others}
      style={{
        height: size,
        width: size,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor,
        color: textColor,
        fontWeight: "bold",
        ...others.style,
      }}
    >
      <div
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: others.style?.fontSize ? others.style.fontSize : size * 0.5,
        }}
      >
        {playerNumber || "?"}
      </div>
    </div>
  );
}
